export default "__VITE_ASSET__5ada84a2__"